import * as Gerenciamento from './Gerenciamento';

export default {
  Gerenciamento,
};
